import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import './i18n';
import { AppConfig } from './config/AppConfig';
import { SnackbarProvider } from 'notistack';
import { Button, CssBaseline, ThemeProvider } from '@mui/material';
import lightTheme from './themes/lightTheme';
import { useState, useMemo, useEffect } from 'react';
import darkTheme from './themes/darkTheme';
import { useDispatch } from 'react-redux';
import { monitorAuthState, restoreSession } from './slices/authSlice';
const App = () => {
  const apiUrl = AppConfig.apiUrl;
  const otherKey = AppConfig.analyticsKey;
  const dispatch = useDispatch();

  console.log('API URL:', apiUrl);
  console.log('Other Key:', otherKey);
  const [themeMode, setThemeMode] = useState<'light' | 'dark'>('light');

  // Use memoization to avoid unnecessary re-rendering
  const theme = useMemo(
    () => (themeMode === 'light' ? lightTheme : darkTheme),
    [themeMode],
  );
  useEffect(() => {
    const initializeAuth = async () => {
      await dispatch(restoreSession()); // Ensure session is restored first
      dispatch(monitorAuthState()); // Then start monitoring Firebase auth state
    };
    initializeAuth();
  }, [dispatch]);
  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  return (
    
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3} // Maximum number of snackbars to show at once
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <AuthProvider>
          <AppRoutes themeMode={themeMode} toggleTheme={toggleTheme} />
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
  );
};

export default App;
